// --- Libraries
import childProcess from 'child_process';
import crypto from 'crypto';
import formatter from 'error-formatter';
import os from 'os';
import moment from 'moment';
import Promise from 'bluebird';
// --- Modules
import configure from './configure';

function isNumeric(num) {
  return !isNaN(num);
}

function format(err, data) {
  if (data) {
    err.data = data;
  }

  return err;
}

export function generateHash(obj) {
  return crypto.createHash('sha256').update(JSON.stringify(obj)).digest('hex');
}

export function formatError(err, data) {
  return formatter(format(err, data));
}

export function formatErrorToJSON(err, data) {
  return formatter.json(format(err, data));
}

export function execScript(cmd, args) {
  var cli = childProcess.spawn(cmd, args);
  console.log('changing pid to', cli.pid);
  global.sdkEventEmitter.emit('update-pid', cli.pid);

  console.log('ready to spawn', cmd, args);
  return new Promise((resolve, reject) => {
    var stdout = '';
    var stderr = '';
    cli.stdout.on('data', (data) => {
      stdout += data;
    });

    cli.stderr.on('data', (data) => {
      stderr += data;
    });

    cli.on('exit', (code) => {
      //console.log('command is done', stderr, stdout);

      if (stderr) {
        console.log('command got stderr', stderr);
        //reject(stderr);
        // Log it?
      }

      global.sdkEventEmitter.emit('update-pid', process.pid);
      resolve(stdout.split(/\r?\n/));
    });
  });
}

export function parsePowershellOutput(lines) {
  let i = 0;
  let objects = {};
  let location = '';
  let ref = objects;
  while (i < lines.length) {
    const line = lines[i];
    if (line.indexOf('++START') !== -1) {
      const breaks = line.split('::');
      location += `/${breaks[1]}`;

      if (isNumeric(breaks[1])) {
        ref[+breaks[1]] = line.indexOf('[]') !== -1 ? [] : {};
        ref = ref[+breaks[1]];
      } else {
        ref[breaks[1]] = line.indexOf('[]') !== -1 ? [] : {};
        ref = ref[breaks[1]];
      }
    } else if (line.indexOf('++STOP') !== -1) {
      const path = location.split('/');

      ref = objects;
      path.slice(1, path.length - 1).forEach((p) => {
        if (isNumeric(p)) {
          ref = ref[+p];
        } else {
          ref = ref[p];
        }
      });

      location = path.slice(0, path.length - 1).join('/');
    } else if (location !== '' && line.indexOf(':') !== -1) {
      const pair = line.split(':');
      const name = pair[0].trim();
      let value = pair[1].replace(/\r?\n/g, '').trim();

      if (value === 'True' || value === 'False') {
        value = value === 'True';
      } else if (!(typeof value === 'string' && value === '') && isNumeric(value)) {
        value = +value;
      } else if (typeof value === 'string' && value.match(/\d{1,2}\/\d{1,2}\/\d{4} \d{1}:\d{2}:\d{2} (AM|PM)/) !== null) {
        value = moment(value, 'MM/DD/YYYY hh:mm:ss A').toDate();
      } else if (typeof value === 'string' && value.match(/\d{1,2}\/\d{1,2}\/\d{4} \d{1}/) !== null) {
        value = moment(value, 'MM/DD/YYYY h').toDate();
      }

      ref[name] = value;
    }

    i++;
  }

  return objects;
}
